import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import SiteLayout from "@/components/site/SiteLayout";
import ScrollToTop from "@/components/site/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Framework from "@/pages/Framework";
import Snapshot from "@/pages/Snapshot";
import Report from "@/pages/Report";
import Foundations from "@/pages/Foundations";
import Workshop from "@/pages/Workshop";
import Resources from "@/pages/Resources";
import Discovery from "@/pages/Discovery";
import Contact from "@/pages/Contact";
import ComingSoon from "@/pages/ComingSoon";
import AdminLogin from "@/pages/admin/AdminLogin";
import InsightsCenter from "@/pages/admin/InsightsCenter";
import RequireAdmin from "@/pages/admin/RequireAdmin";

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                    {/* Admin (no site chrome) */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={
                            <RequireAdmin>
                                <InsightsCenter />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/admin/insights"
                        element={
                            <RequireAdmin>
                                <InsightsCenter />
                            </RequireAdmin>
                        }
                    />

                    {/* Public site */}
                    <Route element={<SiteLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/framework" element={<Framework />} />
                        <Route path="/snapshot" element={<Snapshot />} />
                        <Route path="/report/:id" element={<Report />} />
                        <Route
                            path="/report"
                            element={
                                <ComingSoon
                                    slug="report"
                                    eyebrow="HUMAN+ Executive Report"
                                    title="Take the Snapshot to generate your Executive Report."
                                    milestone="now (no ID supplied)"
                                />
                            }
                        />
                        <Route path="/foundations" element={<Foundations />} />
                        <Route path="/workshop" element={<Workshop />} />
                        <Route path="/resources" element={<Resources />} />
                        <Route path="/discovery" element={<Discovery />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route
                            path="*"
                            element={
                                <ComingSoon
                                    slug="not-found"
                                    eyebrow="Page not found"
                                    title="That page doesn't exist yet."
                                    milestone="this build"
                                />
                            }
                        />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
            </div>
        </HelmetProvider>
    );
}

export default App;
